export const tableEntity = (t) => [
  { id: "entity_name", label: t('company:complianceProgram.show.table.name') },
  { id: "entity_type", label: t('company:complianceProgram.show.table.type'), type: "type-entity" },
  { id: "status", label: t('company:complianceProgram.show.table.status'), type: "status"},
  { id: "maturity_level", label: t('company:complianceProgram.show.table.maturity'), type: "maturity-level" },
  { id: "actions", type: "actions", label: "" },
];
